import React from "react";
import { map, take, filter, includes, differenceBy } from "lodash";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { pure } from "recompose";

import OnePanel from "./OnePanel";
import Text from "./Text";
import GenericTable from "./GenericTable";
import { dFlex, dFlexC, flex1, panelHeaderStyle } from "./styles";
import { teamColor } from "./utils";
import { numericSuffix } from "services/utils";

const calculateReleaseDate = (product, rounds) => {
  const { total_duration } = product;
  const round = rounds.find(i => i.id === product.round);

  let duration = total_duration;
  if (round && round.number > 1 && duration >= 12) {
    duration += (round.number - 1) * 12;
  }

  let year = parseInt((duration - 1) / 12, 10);
  let quarter = duration - year * 12;

  year += 1;
  quarter = quarter / 3 + 1;
  if (quarter >= 5) {
    quarter -= 4;
    year += 1;
  }

  if (round && year < round.number) {
    year = round.number;
  }

  return `Year ${year}, Q${quarter}`;
};

const popoverComponent = (product, rounds) => (
  <Popover
    id={`popover-product-features-${product.id}`}
    title="Product's Features"
    bsClass="map-popover popover"
  >
    <b>Resolution:</b> {product.pixels_rank}
    <br />
    <b>Sensitivity:</b> {product.sensitivity_rank}
    <br />
    <b>Power:</b> {product.power_rank}
    <br />
    <b>Temperature:</b> {product.temp_range_rank}
    <br />
    <b>Release Date:</b> {calculateReleaseDate(product, rounds)}
  </Popover>
);

const TopTable = pure(({ data, rounds }) => (
  <div style={{ marginTop: "2em", marginBottom: "1.5em" }}>
    <table>
      <tbody>
        {map(data, (row, idx) => (
          <tr key={idx}>
            <td>{numericSuffix(row.rank)}</td>
            <td style={{ padding: "10px" }}>
              <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="bottom"
                overlay={popoverComponent(row.product, rounds)}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "15px",
                    height: "15px",
                    backgroundColor: row.color
                  }}
                />
              </OverlayTrigger>
            </td>
            <td>{row.name}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
));

const autoData = (teams, data) =>
  map(data, item => ({
    name: item.product.name,
    rank: item.rank_auto,
    color: teamColor(teams, item.team),
    product: item.product
  }));

const mobileData = (teams, data) =>
  map(data, item => ({
    name: item.product.name,
    rank: item.rank_mobile,
    color: teamColor(teams, item.team),
    product: item.product
  }));

const headerStyle = {
  ...panelHeaderStyle,
  textTransform: "uppercase",
  fontSize: "16px"
};

const MarketingPositioning = pure(
  ({ topPerformers, teams, teamId, rounds }) => {
    const teamsIds = map(teams, team => team.id);
    const topPerformersMobile =
      topPerformers && topPerformers["Mobile"]
        ? filter(topPerformers["Mobile"], item => includes(teamsIds, item.team))
        : [];
    const topPerformersMobileTeamSpecific = topPerformersMobile.filter(
      i => i.team === teamId
    );
    const topPerformersAuto =
      topPerformers && topPerformers["Auto"]
        ? filter(topPerformers["Auto"], item => includes(teamsIds, item.team))
        : [];
    const topPerformersAutoTeamSpecific = topPerformersAuto.filter(
      i => i.team === teamId
    );
    const topPerformersTeamSpecific = [
      ...topPerformersMobileTeamSpecific,
      ...differenceBy(
        topPerformersAutoTeamSpecific,
        topPerformersMobileTeamSpecific,
        "id"
      )
    ];

    return (
      <div style={dFlex}>
        <OnePanel title="Customer Survey" style={flex1}>
          <Text>
            Given your product's price, features, and the lead time, in relation
            to your competitors', customers ranked your products as follows:
          </Text>

          <div>
            <GenericTable
              header={[
                { name: "Product Name", highlighted: true },
                { name: "Ranked (Auto)", highlighted: true },
                { name: "Ranked (Mobile)", highlighted: true }
              ]}
              rows={map(topPerformersTeamSpecific, el => [
                el.product.name,
                numericSuffix(el.rank_auto),
                numericSuffix(el.rank_mobile)
              ])}
            />
          </div>
        </OnePanel>
        <div style={{ ...flex1, ...dFlexC, alignItems: "center" }}>
          <h3 style={headerStyle}>Top 5 Ranked Products Mobile</h3>
          <TopTable
            data={mobileData(teams, take(topPerformersMobile, 5))}
            rounds={rounds}
          />
          <h3 style={headerStyle}>Top 5 Ranked Products Auto</h3>
          <TopTable
            data={autoData(teams, take(topPerformersAuto, 5))}
            rounds={rounds}
          />
        </div>
      </div>
    );
  }
);

export default MarketingPositioning;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketingPositioning.js